import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";

import notificationState from "../../states/notificationState";
import defineConf from "../../config/defineConf";

import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import getSchema from "../../lib/api/getSchema";
import TkOutSourcingInputInspectionRegisterButton from "../input/TkOutSourcingInputInspectionRegisterButton.js";
import TkOutSourcingInputInspectionUpdateButton from "../input/TkOutSourcingInputInspectionUpdateButton";
import TkOutSourcingInputInspectionInputButton from "../input/TkOutSourcingInputInspectionInputButton";

function TkOutSourcingInputInspection(props) {
    const id = "TkOutSourcingInputInspection";
    const table = "TkOutSourcingInputInspection";
    const view = "TkVwOutSourcingInputInspection";

    const { t } = useTranslation();

    const [height, setHeight] = useState(0);

    const [modifiedSchema, setModifiedSchema] = useState();

    const [tkOutSourcingInputInspectionSchema, setTkOutSourcingInputInspectionSchema] = useState();
    const [tkOutSourcingInputInspectionGrid, setTkOutSourcingInputInspectionGrid] = useState();
    const [tkOutSourcingInputInspectionIsEmpty, setTkOutSourcingInputInspectionDataIsEmpty] = useState();
    const [tkOutSourcingInputInspectionApi, setTkOutSourcingInputInspectionApi] = useState();
    const [tkOutSourcingInputInspectionSelect, setTkOutSourcingInputInspectionSelect] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        let mounted = true;

        window.addEventListener("resize", handleResize);
        handleResize();

        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setTkOutSourcingInputInspectionSchema(schema);
            }
        })();

        return () => {
            mounted = false;
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        let modifiedSchema = cloneDeep(tkOutSourcingInputInspectionSchema);

        if (modifiedSchema) {
            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "qcResult":
                        column.required = false;
                        break;

                    default:
                        break;
                }
            }

            setModifiedSchema(modifiedSchema);
        }
    }, [tkOutSourcingInputInspectionSchema]);

    useEffect(() => {
        let mounted = true;

        (async () => {
            if (tkOutSourcingInputInspectionGrid && mounted) {
                tkOutSourcingInputInspectionGrid.selectionChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setTkOutSourcingInputInspectionSelect(grid.selectedItems[0]);
                    }
                });

                tkOutSourcingInputInspectionGrid.itemsSourceChanged.addHandler((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setTkOutSourcingInputInspectionSelect(grid.selectedItems[0]);
                    }
                });
            }
        })();

        return () => {
            mounted = false;
        };
    }, [tkOutSourcingInputInspectionGrid]);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    return (
        <div style={{ height: height }}>
            <BasicCrudScreenType
                id={id}
                view={view}
                headerTitle={t("term.outSourcingInputInspection")}
                onLoadData={(data) => {
                    setTkOutSourcingInputInspectionDataIsEmpty(data.length < 1 ? true : false);
                }}
                onInitialized={(grid) => {
                    grid.selectionMode = "Row";
                    setTkOutSourcingInputInspectionGrid(grid);
                }}
                onApiInitialized={(api) => {
                    setTkOutSourcingInputInspectionApi(api);
                }}
                noExcel
                onAppendButtonInFrontOfSearch={() => (
                    <React.Fragment>
                        <BasicCrudScreenActionItemLayout>
                            <TkOutSourcingInputInspectionRegisterButton
                                id={id}
                                schema={tkOutSourcingInputInspectionSchema}
                                refresh={tkOutSourcingInputInspectionApi}
                                onSuccess={onSuccess}
                            />

                            <TkOutSourcingInputInspectionUpdateButton
                                id={id}
                                schema={modifiedSchema}
                                grid={tkOutSourcingInputInspectionGrid}
                                refresh={tkOutSourcingInputInspectionApi}
                                disabled={
                                    !tkOutSourcingInputInspectionSelect || tkOutSourcingInputInspectionSelect?.inputDate
                                }
                                onSuccess={onSuccess}
                            />

                            <TkOutSourcingInputInspectionInputButton
                                id={id}
                                schema={tkOutSourcingInputInspectionSchema}
                                grid={tkOutSourcingInputInspectionGrid}
                                refresh={tkOutSourcingInputInspectionApi}
                                disabled={
                                    !tkOutSourcingInputInspectionSelect ||
                                    tkOutSourcingInputInspectionSelect?.qcResult !== defineConf.qcResult.QC_OK ||
                                    tkOutSourcingInputInspectionSelect?.inputDate
                                }
                                onSuccess={onSuccess}
                            />
                        </BasicCrudScreenActionItemLayout>
                    </React.Fragment>
                )}
            />
        </div>
    );
}

export default TkOutSourcingInputInspection;
